import React from 'react';
import AddColumns from './AddColumns/AddColumns';
import SelectedColumns from './SelectedColumns/SelectedColumns';

interface IAttributesProps {
    className?: string;
    selectedColumns: string[];
    setSelectedColumns: (columns: string[]) => void;
}
const Attributes = ({ className, selectedColumns, setSelectedColumns }: IAttributesProps) => (
    <div className={`Attributes d-flex flex-column ${className}`}>
        <SelectedColumns selectedColumns={selectedColumns} setSelectedColumns={setSelectedColumns} />
        <hr />
        <AddColumns selectedColumns={selectedColumns} setSelectedColumns={setSelectedColumns} />
    </div>
);

export default Attributes;
